export const BIT_SITE_ID = 9
export const IS_EMULATE_MODE = true
export const IS_EXCLUDE_APP_MANAGER = true
export const EIOT_APP_MANAGER_URL = 'http://localhost:61770/'
export const EIOT_APP_MANAGER_HUBNAME = 'LWAppManagerHub'
export const EIOT_DEVICE_MANAGER_URL = 'http://localhost:60559/' //http://192.168.190.80:60559/
export const EIOT_DEVICE_MANAGER_HUBNAME = 'deviceManagerHub'
